<template>
    <div v-if="src" :class="['text-center', wrapperClass]">
        <img :src="src" :alt="alt" :class="['w-full max-w-full', imageClass]" />
    </div>
</template>

<script>

export default {
  name: 'FluidImage',
  props: {
    src: {
        type: String,
        default: ""
    },
    alt: {
        type: String,
        default: ""
    },
    wrapperClass: {
        type: String,
        default: ""
    },
    imageClass: {
        type: String,
        default: ""
    },
  }
 
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>